export default __webpack_public_path__ + "static/warfame_div-4eef9942c7ec3318a9969855e801deb9.avif";